<button
  type="button"
  class="lk-panel-link"
  [class.lk-panel-link--inline]="variant() === 'inline'"
  [class.lk-panel-link--highlighted]="highlighted()"
  [attr.data-test-id]="'locks-keys-panel-link-' + panel()"
  (click)="open()"
>
  <span class="lk-panel-link__icon">
    <i eIcon [icon]="definition().icon" family="solid"></i>
  </span>
  <span class="lk-panel-link__text">
    <span class="lk-panel-link__label">{{ label() }}</span>
    @if (hint()) {
      <span class="lk-panel-link__hint">{{ hint() }}</span>
    }
  </span>
  <span class="lk-panel-link__chevron">
    <i eIcon icon="chevron-right" family="solid"></i>
  </span>
</button>
